import { useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { Navigate, Outlet } from "react-router-dom";
import NotFound from "@pages/NotFound";

interface ProtectRoutesByStatusListProps {
  allowedStatus: string[];
}

const ProtectRoutesByStatusList = ({ allowedStatus }: ProtectRoutesByStatusListProps) => {
  const loan_status = useSelector((state: RootState) => state.register.loan_status);
  const process_page = useSelector((state: RootState) => state.app.process_page);
  const previus_status = useRef<string>("");

  useEffect(() => {
    setTimeout(() => {
      previus_status.current = loan_status;
    }, 2000);
  }, [loan_status]);

  if (
    allowedStatus.includes(loan_status) ||
    allowedStatus.includes(previus_status.current) ||
    allowedStatus[0] === "*"
  ) {
    return <Outlet />;
  }

  if (process_page) {
    return <Navigate to={process_page} replace />;
  }

  return <NotFound />;
};

export default ProtectRoutesByStatusList;
